import { DELETE, GET, PATCH, POST } from '../../common/common.service'
import endpointsPopulations from './enpoints'

const ConventionsService = {
  getAll: async ({ filter, sort, limit, skip }) =>
    GET(endpointsPopulations.LOAD(filter, sort, limit, skip)),
  getById: async (id) => GET(endpointsPopulations.LOAD_BY_ID(id)),
  create: async (body) => POST(endpointsPopulations.CREATE, body),
  update: async ({ _id, body }) =>
    PATCH(endpointsPopulations.LOAD_BY_ID(_id), body),
  remove: async (id) => DELETE(endpointsPopulations.LOAD_BY_ID(id)),
}

export default ConventionsService
